import { render, staticRenderFns } from "./AskHeading.vue?vue&type=template&id=1ec88f6a&scoped=true&"
import script from "./AskHeading.vue?vue&type=script&lang=js&"
export * from "./AskHeading.vue?vue&type=script&lang=js&"
import style0 from "./AskHeading.vue?vue&type=style&index=0&id=1ec88f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec88f6a",
  null
  
)

export default component.exports